import { render, staticRenderFns } from "./NoItemsCard.vue?vue&type=template&id=66c50a0c&scoped=true&"
import script from "./NoItemsCard.vue?vue&type=script&lang=js&"
export * from "./NoItemsCard.vue?vue&type=script&lang=js&"
import style0 from "./NoItemsCard.vue?vue&type=style&index=0&id=66c50a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c50a0c",
  null
  
)

export default component.exports